import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import { Hammer, Users, ArrowRight } from "lucide-react";

interface DIYvsDoneForYouProps {
  diyTitle?: string;
  diyPoints?: string[];
  doneForYouTitle?: string;
  doneForYouPoints?: string[];
}

export const DIYvsDoneForYou = ({
  diyTitle = "DIY Approach",
  diyPoints = ["Research and learn the skills yourself", "Time-consuming but low cost", "May require multiple iterations"],
  doneForYouTitle = "Done-For-You (Leaf Rush)",
  doneForYouPoints = ["Expert implementation from day one", "Fast turnaround with guaranteed results", "Ongoing support and optimization"],
}: DIYvsDoneForYouProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <Hammer className="h-5 w-5" />
            {diyTitle}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 text-sm text-muted-foreground">
            {diyPoints.map((point, index) => (
              <li key={index}>• {point}</li>
            ))}
          </ul>
        </CardContent>
      </Card>
      
      <Card className="border-primary border-2 bg-primary/5">
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2 text-primary">
            <Users className="h-5 w-5" />
            {doneForYouTitle}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <ul className="space-y-2 text-sm">
            {doneForYouPoints.map((point, index) => (
              <li key={index}>• {point}</li>
            ))}
          </ul>
          <NavLink to="/websites/">
            <Button size="sm" className="w-full gap-2">
              See Website Pricing
              <ArrowRight className="h-4 w-4" />
            </Button>
          </NavLink>
        </CardContent>
      </Card>
    </div>
  );
};
